import { useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './EmptyContent.module.css';

import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/useRedux';
import { menuChanged } from '../../features/infoSlice';

import Input from '../Input';

import { EMPTY_MSG, SEARCH_DATA, UPLOAD } from '../../constants';
import { isMobile } from '../../utils/util';

interface EmptyContentProps {
  name: string;
}

export default function EmptyContent({ name }: EmptyContentProps) {
  const cx = classNames.bind(styles);

  const messages = EMPTY_MSG;
  const id = `${name}_empty_upload`;

  function Label() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const labelRef = useRef<HTMLLabelElement>(null);
    const [isUploadDropdownOpen, setIsUploadDropdownOpen] = useState(false);
    const isShare = name === 'share';
    const btnName = isShare ? SEARCH_DATA : UPLOAD;

    const clickHandler = () => {
      if (isShare) {
        navigate('/home/search');
        dispatch(menuChanged('search'));
      } else if (name === 'mydrive') {
        setIsUploadDropdownOpen(!isUploadDropdownOpen);
      }
    };

    return (
      <>
        <label
          htmlFor={id}
          className={cx('main_upload')}
          onClick={clickHandler}
          ref={labelRef}
        >
          <span>{btnName}</span>
        </label>
      </>
    );
  }

  return (
    <div className={cx('empty_upload')}>
      <p className={cx('desc')}>{messages[name]}</p>
      {!isMobile &&
        (name !== 'library' ? (
          <Label />
        ) : (
          <Input type="file" id={id}>
            <Label />
          </Input>
        ))}
    </div>
  );
}
